import React from "react";
import styled from "styled-components";
import { gb } from "../styles/theme";

const SearchContainer = styled.div`
  width: 100%;
`;

const Input = styled.input`
  width: 100%;
  padding: 8px 8px 8px 10px;
  background: ${gb.light};
  border: 2px solid ${gb.dark};
  color: ${gb.dark};
  font-size: 8px;
  line-height: 1.4;
  image-rendering: pixelated;
  box-shadow: inset 2px 2px 0 rgba(15, 56, 15, 0.25);

  &::placeholder {
    color: ${gb.mid};
    text-transform: uppercase;
  }

  &:focus {
    outline: none;
    background: ${gb.lightest};
  }
`;

interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
}

export const SearchBar: React.FC<SearchBarProps> = ({ value, onChange }) => {
  return (
    <SearchContainer>
      <Input
        type="text"
        placeholder="NAME / NO."
        value={value}
        onChange={(e) => onChange(e.target.value)}
        aria-label="Search Pokémon"
        spellCheck={false}
      />
    </SearchContainer>
  );
};
